import React from "react";
import { connect } from "react-redux";
import { Button, Popover, PopoverContent } from "reactstrap";
/* import Select from 'react-select';*/
import auth from "store/tenant/auth.js";
import SearchSuggestion from "./RenderAutoSuggest.js";
import RequestProperties from "../request.props.js";
import Presenter from "../../presenter.js";
import ModalDetailSite from "./modal/ModalDetailSite.js";
import JobMap from "./JobMap.js";
import UserHelper from "../../../../helper/user.js";
import PermissionProperties from "../../../../config/permission.js";
import { StoreUserInfoFromMobile } from "user/action";
import { UpdateAllTenantSession } from "store/tenant/action";
import windowStop from "../../../../utils/windowStop.js";
//import {RenderMapLocation} from "./JobMap.js";
//import ModalHelper from './modal.js'

const { ReactNativeWebView } = window;

class JobList extends React.Component {
  constructor(props) {
    super(props);
    //console.log(props)
    this.state = {
      dontRender: true,
      filterField: "name",
      filterName: "SITE",
      findedData: [],
      modalDetail: false,
      popoverOpen: false,
      popoverOpenFilter: false,
      query: "",
      RowCount: 0,
      allRowCount: 0,
      selectedItem: null,
      siteData: [],
      allSiteData: [],
      siteStatus: [],
      allSiteStatus: [],
      searchItems: null,
      showInactive: false
    };
    this.query = "";
    this.searchItems = null;
    // this.loadData = this.loadData.bind(this);
    this.togglePopOverFilter = this.togglePopOverFilter.bind(this);
    this.toggleFilterList = this.toggleFilterList.bind(this);
    this.toggleModalDetail = this.toggleModalDetail.bind(this);
    this.closeModalDetail = this.closeModalDetail.bind(this);
    this.searchKeyHandler = this.searchKeyHandler.bind(this);
    this.getFilterAutoSuggestionItems = this.getFilterAutoSuggestionItems.bind(
      this
    );
    this.handleMobile = this.handleMobile.bind(this);
    this.handleShowInactive = this.handleShowInactive.bind(this);
  }
  searchKeyHandler(e, item = null) {
    // console.log(e)
    // if (this.state.findedData !== null || this.state.findedData.length)
    if (e.key === "Enter" || item === 1) {
      this.loadData("find");
    }
  }

  changeFilterHadler(val) {
    this.query = val.value;
    // this.setState({
    //   query : val.value
    // })
    if (val != null) {
      this.loadData("find");
    }
  }

  getFilterAutoSuggestionItems(filter, data) {
    let items = [];
    const { showInactive } = this.state;
    const tenantCredential = auth.GetCredential();
    const inactiveName =
      tenantCredential.in_active_site_status &&
      tenantCredential.in_active_site_status.Name;
    for (let i = 0; i < data.length; i++) {
      let val = data[i];
      if (filter.includes("type")) {
        items = this.state.siteType;
      } else if (filter.includes("project")) {
        if (val.Status.Name !== inactiveName || showInactive)
          items.push(val.ProjectName);
      } else if (filter.includes("status")) {
        items = this.state.siteStatus;
      } else {
        if (val.Name !== inactiveName || showInactive) items.push(val.Name);
      }
    }
    return items;
  }

  toggleModalDetail(data) {
    this.setState({
      modalDetail: !this.state.modalDetail,
      dontRender: true,
      selectedItem: data
    });
  }

  togglePopOverFilter() {
    this.setState({
      popoverOpenFilter: !this.state.popoverOpenFilter
    });
  }

  toggleFilterList(label, filterValue) {
    //console.log('hit')
    this.setState({
      filterName: label,
      filterField: filterValue
    });
  }

  closeModalDetail() {
    this.setState({
      modalDetail: false
    });
  }

  loadData(action = "READ") {
    Presenter.ReadSite(
      RequestProperties.ReadPropsSite(
        action,
        this,
        this.onReadSuccess,
        this.onReadFailed
      )
    );
  }

  onReadSuccess(params, response) {
    if (params.action === "find") {
      this.self.setState({
        findedData: response.data.results
      });
    } else {
      const { showInactive } = this.self.state;
      const tenantCredential = auth.GetCredential();
      const inactiveName =
        tenantCredential.in_active_site_status &&
        tenantCredential.in_active_site_status.Name;
      const siteDataFiltered = showInactive
        ? response.data
        : response.data.filter(item => item.Status.Name !== inactiveName);
      this.self.setState({
        siteData: siteDataFiltered,
        allSiteData: response.data,
        searchItems: this.self.getFilterAutoSuggestionItems(
          this.self.state.filterField,
          response.data
        ),
        allRowCount: response.data.length,
        RowCount: siteDataFiltered.length
      });
      // this.self.searchItems = this.self.getFilterAutoSuggestionItems(this.self.state.filterField,response.data);
    }
  }

  onReadFailed(params, response) {
    console.log("Read failed");
  }

  onButtonFilterClick() {
    this.togglePopOverFilter();
    // this.searchItems = this.getFilterAutoSuggestionItems(this.state.filterField,this.state.siteData);
    this.setState({
      // searchItems : this.getFilterAutoSuggestionItems(this.state.filterField,this.state.siteData),
      dontRender: true
    });
  }

  loadDataMaster() {
    Presenter.ReadMasterSiteType(
      RequestProperties.ReadMasterSiteType(
        "Read",
        this,
        this.onReadMasterSiteTypeSuccess,
        this.onReadFailed
      )
    );
    Presenter.ReadMasterSiteStatus(
      RequestProperties.ReadMasterSiteStatus(
        "Read",
        this,
        this.onReadMasterSiteStatusSuccess,
        this.onReadFailed
      )
    );
  }

  onReadMasterSiteTypeSuccess(params, response) {
    const items = response.data.results.map(val => {
      return val.Name;
    });
    // console.log(items)
    this.self.setState({
      siteType: items
    });
  }
  onReadMasterSiteStatusSuccess(params, response) {
    const { showInactive } = this.self.state;
    const tenantCredential = auth.GetCredential();
    const inactiveName =
      tenantCredential.in_active_site_status &&
      tenantCredential.in_active_site_status.Name;
    const items = response.data.results.map(val => {
      return val.Name;
    });
    this.self.setState({
      allSiteStatus: items,
      siteStatus: showInactive
        ? items
        : items.filter(item => item !== inactiveName)
    });
  }

  handleMobile({ data }) {
    const { tenantReducer, userReducer } = JSON.parse(data);

    this.props.RunRedux(StoreUserInfoFromMobile(userReducer));
    this.props.RunRedux(
      UpdateAllTenantSession({
        LoginLogo: tenantReducer.loginLogo,
        DashboardLogo: tenantReducer.dashboardLogo,
        ReportLogo: tenantReducer.reportLogo,
        CoverageCity: tenantReducer.coverageCity,
        InActiveSiteStatus: tenantReducer.inactiveSiteStatus
      })
    );
  }

  /*  ============ LifeCyle ============ */
  shouldComponentUpdate(nextProps, nextState) {
    // if (nextState.siteData == null){
    //   return false
    // }
    nextState.searchItems = this.getFilterAutoSuggestionItems(
      nextState.filterField,
      nextState.siteData
    );
    return true;
  }

  componentWillReceiveProps(nextProps) {
    if (ReactNativeWebView) {
      if (nextProps.UserReducer.username) {
        this.setState({}, () => {
          this.loadData();
          this.loadDataMaster();
          this.setState({
            // searchItems : this.getFilterAutoSuggestionItems(this.state.filterField,this.state.siteData),
            dontRender: true
          });
        });
      }
    }
  }

  componentDidMount() {
    if (ReactNativeWebView) {
      document.addEventListener("message", this.handleMobile);
      window.addEventListener("message", this.handleMobile);
      ReactNativeWebView.postMessage("mounted");
    } else {
      this.loadData();
      this.loadDataMaster();
      this.setState({
        // searchItems : this.getFilterAutoSuggestionItems(this.state.filterField,this.state.siteData),
        dontRender: true
      });
    }
  }

  componentWillUnmount() {
    if (ReactNativeWebView) {
      document.removeEventListener("message", this.handleMobile);
      window.removeEventListener("message", this.handleMobile);
    }
    windowStop();
  }

  renderButtonAddSite() {
    if (this.props.UserReducer.username) {
      if (
        UserHelper.HasPermission(
          PermissionProperties.ASSET.ASSET.UPDATE,
          this.props.UserReducer
        )
      ) {
        return (
          <div className="float-right">
            <Button
              className="btn btn-lg btn-secondary btn-addsite"
              onClick={() => this.props.history.push("/job/edit-site")}
            >
              <i className="fa fa-plus-square-o" /> Add / Edit Site
            </Button>
          </div>
        );
      } else {
        return null;
      }
    }
    return null;
  }

  handleShowInactive(event) {
    const { allSiteData, allSiteStatus } = this.state;
    const showInactive = event.target.checked;
    const tenantCredential = auth.GetCredential();
    const inactiveName =
      tenantCredential.in_active_site_status &&
      tenantCredential.in_active_site_status.Name;
    const siteDataFiltered = showInactive
      ? allSiteData
      : allSiteData.filter(item => item.Status.Name !== inactiveName);
    const siteStatusFiltered = showInactive
      ? allSiteStatus
      : allSiteStatus.filter(item => item !== inactiveName);
    this.setState({
      siteStatus: siteStatusFiltered,
      siteData: siteDataFiltered,
      searchItems: this.getFilterAutoSuggestionItems(
        this.state.filterField,
        allSiteData
      ),
      RowCount: siteDataFiltered.length,
      showInactive: event.target.checked
    });
  }

  render() {
    const tenantCredential = auth.GetCredential();
    const inactiveName =
      tenantCredential.in_active_site_status &&
      tenantCredential.in_active_site_status.Name;
    return (
      <div className="card no-border">
        <div className="card-block white-background">
          <div className="row">
            <div className="col-sm-5 book-a-tool-title">
              <h4 className="card-title mb-0">
                <span className="icon-briefcase" />
                &nbsp;Job Site Location
              </h4>
              <div className="text-muted m-top-8">
                <div
                  className="pull-left spaceRRR cursor-default"
                  title="Total user"
                >
                  <span className="icon-record" />
                  Total : {this.state.RowCount > 0
                    ? this.state.RowCount
                    : 0}{" "}
                  Sites
                </div>
              </div>
            </div>
            <div className="col-sm-2 input-group mb-2">
              {!ReactNativeWebView && this.renderButtonAddSite()}
            </div>
            <div className="col-sm-5">
              <div className="input-group">
                <div className="input-group-addon white-background">
                  <Button
                    className="btn btn-link btn-filter"
                    id="popoverFilter"
                    onClick={() => this.onButtonFilterClick()}
                  >
                    <i className="fa" />
                    <strong>{this.state.filterName}</strong>
                  </Button>

                  <Popover
                    placement="bottom"
                    isOpen={this.state.popoverOpenFilter}
                    target="popoverFilter"
                    toggle={this.togglePopOverFilter}
                    style={{ minWidth: "154px" }}
                  >
                    <PopoverContent style={{ padding: "0px" }}>
                      <ul
                        className="pagination"
                        style={{ display: "initial" }}
                        onClick={this.togglePopOverFilter}
                      >
                        <li className="page-item list-border-bottom">
                          <a
                            onClick={event =>
                              this.toggleFilterList("SITE", "name")
                            }
                            className="page-link"
                            style={{ border: 0 }}
                            role="button"
                          >
                            SITE
                          </a>
                        </li>
                        <li className="page-item list-border-bottom">
                          <a
                            onClick={event =>
                              this.toggleFilterList("TYPE", "type")
                            }
                            className="page-link"
                            style={{ border: 0 }}
                            role="button"
                          >
                            TYPE
                          </a>
                        </li>
                        <li className="page-item list-border-bottom">
                          <a
                            onClick={event =>
                              this.toggleFilterList("STATUS", "status")
                            }
                            className="page-link"
                            style={{ border: 0 }}
                            role="button"
                          >
                            STATUS
                          </a>
                        </li>
                        <li className="page-item list-border-bottom">
                          <a
                            onClick={event =>
                              this.toggleFilterList("PROJECT", "project")
                            }
                            className="page-link"
                            style={{ border: 0 }}
                            role="button"
                          >
                            PROJECT
                          </a>
                        </li>
                      </ul>
                    </PopoverContent>
                  </Popover>
                </div>
                <div className="form-control" style={{ padding: "0px" }}>
                  <div className="input-group">
                    <SearchSuggestion self={this} />
                  </div>
                </div>
                <div className="input-group-addon email-notification">
                  <label className="spaceRRR mb0">Show Inactive</label>
                  <label className="switch switch-sm switch-text switch-primary mb0">
                    <input
                      onChange={event => this.handleShowInactive(event)}
                      name="showNotification"
                      type="checkbox"
                      className="switch-input"
                      checked={this.state.showInactive}
                    />
                    <span
                      className="switch-label"
                      data-on="Yes"
                      data-off="No"
                    />
                    <span className="switch-handle" />
                  </label>
                </div>
                {/*<Select
                    name="TypeAlias"
                    className="form-control"
                    placeholder="Type to Search"
                    style = {{
                      padding : 0
                    }}
                    value={this.state.query}
                    options={this.state.searchItems}
                    onKeyPress={(e) => this.searchKeyHandler(e)}
                    onFocus={(event) => this.setState({dontRender : false})}
                    onChange={(val) => this.changeFilterHadler(val)}
                  />*/}
              </div>
            </div>
            <div className="col-sm-7 ">
              <div className="input-group" />
            </div>
          </div>
          {/*---- body ----*/}
          <div className="card m-top-15">
            <JobMap self={this} />
          </div>

          <ModalDetailSite
            inactiveName={inactiveName}
            modalDetail={this.state.modalDetail}
            dontRender={() => this.setState({ dontRender: true })}
            closeModalDetail={this.closeModalDetail}
            selectedItem={this.state.selectedItem}
            UserReducer={this.props.UserReducer}
            history={this.props.history}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  //console.log(state)
  return {
    //Reducer: state.UserModelReducer,
    UserReducer: state.UserReducer
  };
};

const mapDispatchToProps = dispatch => {
  return {
    RunRedux: data => {
      dispatch(data);
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(JobList);



// WEBPACK FOOTER //
// ./src/App/topmenu/job/helper/component/JobList.js